import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderService, Header } from '../../common/header/header.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { ApplicationService } from '../../application/application.service';
import { Application } from '../../application/application';
import { LoginService } from '../../login/login.service';
import { environment } from '../../../environments/environment';
import { DownpaymentService } from '../down-payment/down-payment.service';

declare var $: any;

@Component({
  selector: 'zest-down-payment-fail',
  templateUrl: './down-payment-fail.component.html',
  styleUrls: ['./down-payment-fail.component.scss']
})
export class DownPaymentFailComponent implements OnInit {

  private loanApplicationId: string;
  private timer: any;

  public linkStatus: string;
  public application: Application;
  public headerMessage: string;
  public footerMessage: string;
  public extraHeader: string;
  public contentLoaded = false;
  public image: string;
  public statusText: string;
  public showCard = true;
  public s3BucketUrl: string = environment.s3BucketUrl;
  public mambuId: string;

  constructor(private headerService: HeaderService, private router: Router, private downpaymentService: DownpaymentService, private loaderService: LoaderService, private route: ActivatedRoute, private applicationService: ApplicationService, private loginService: LoginService) { }

  ngOnInit() {
    this.linkStatus = this.route.snapshot.paramMap.get('state');
    this.route.queryParams.subscribe(value => {
      this.loanApplicationId = value.applicationId;
      if (!this.linkStatus) {
        this.linkStatus = value.errorCode;
      }
      if (this.loanApplicationId && this.linkStatus) {
        this.getLoanApplicationDetails();
      }
    });
    this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
  }
  addSelect2Listeners() {
    $('#selectBank').on('change', (event) => {
      // this.changeBank($(event.target).val());
    });
    $('#selectBank').on('select2:close', function () {
      $('input.select2-search__field').attr('placeholder', null);
    });
  }
  setMessages() {
    switch (this.linkStatus) {
      case ('success'): {
        this.headerMessage = 'Downpayment received';
        this.footerMessage = 'To complete the application';
        this.extraHeader = 'Your order has been booked';
        this.image = 'check-circle.svg';
        this.statusText = 'Your order summary';
        break;
      }
      case ('LOAN_ALREADY_DEPOSIT_PAID'): {
        this.headerMessage = 'Downpayment already paid';
        this.footerMessage = 'To complete the application';
        this.extraHeader = 'Your order has been booked';
        this.image = 'already_paid_dp.png';
        this.statusText = 'You have already made the downpayment for the following order';
        break;
      }
      case ('fail'): {
        this.headerMessage = 'Payment failed';
        this.footerMessage = 'To try again';
        this.extraHeader = 'Your order could not be booked';
        this.statusText = 'Your order summary';
        this.image = 'fail.png';
        break;
      }
      case ('PENDING_TRANSACTION'): {
        this.headerMessage = 'Downpayment pending';
        this.footerMessage = '';
        this.extraHeader = 'Please hold on';
        this.statusText = 'Transaction in progress';
        this.image = 'pending.png';
        this.checkPendingTransactions();
        break;
      }
      case ('LOAN_CANCELLED'): {
        this.headerMessage = 'Link expired';
        this.footerMessage = 'To apply for a new loan';
        this.extraHeader = 'Your order could not be booked';
        this.statusText = 'You have cancelled your loan application for the following order ';
        this.image = 'loan_cancelled.png';
        break;
      }
      case ('INVALID_TOKEN' || 'LOAN_APPLICATION_NOT_FOUND' || 'INVALID_LOAN_APPLICATION_CUSTOMER_MAPPING' || 'TOKEN_ALREADY_USED'): {
        this.showCard = false;
        this.headerMessage = 'Link expired';
        this.footerMessage = 'To complete the above application';
        this.extraHeader = 'Book your order';
        this.image = 'link_expired.png';
        this.statusText = 'You have a loan application in progress';
        break;
      }
      default: {
        this.showCard = false;
        this.headerMessage = 'Link expired';
        this.footerMessage = 'To complete the above application';
        this.extraHeader = 'Book your order';
        this.image = 'link_expired.png';
        this.statusText = 'You have a loan application in progress';
        break;
      }
    }
  }
  checkPendingTransactions() {
    this.downpaymentService.getPendingTranscationWithoutCustomerId(this.application.ApplicationId).subscribe(response => {
      if (response.status === 'CHARGED') {
        clearTimeout(this.timer);
        this.router.navigate(['/application/payment-status/success'], { queryParams: { 'applicationId': this.application.ApplicationId } });
      } else if (response.status === null) {
        clearTimeout(this.timer);
        this.router.navigate(['/application/payment-status/fail'], { queryParams: { 'applicationId': this.application.ApplicationId } });
      } else if (!this.timer) {
        this.timer = setInterval((fn) => { this.checkPendingTransactions(); }, 5000);
      }
    });
  }
  login() {
    this.loginService.goToLoginUrl(true);
  }
  getLoanApplicationDetails() {
    this.applicationService.getMambuLoan(this.loanApplicationId).subscribe(response => {
      this.mambuId = response.MambuLoanId;
    });
    this.applicationService.getOrderDetails(this.loanApplicationId).subscribe(response => {
      this.applicationService.saveApplication(response);
      this.application = this.applicationService.getApplication();
      this.setMessages();
      this.applicationService.getMerchantRoutes(this.applicationService.getApplication().MerchantName.toLowerCase()).subscribe(response => {
        this.applicationService.setRouteConfigs(response);
        this.headerService.ShowHeaderSource.next(new Header(1, true, 50, true, 'Downpayment', false));
        this.contentLoaded = true;
      }, error => {
        this.applicationService.getMerchantRoutes().subscribe(response => {
          this.applicationService.setRouteConfigs(response);
          this.headerService.ShowHeaderSource.next(new Header(1, true, 50, true, 'Downpayment', false));
          this.contentLoaded = true;
        });
      });
    });
  }

}
